// extracted by mini-css-extract-plugin
module.exports = {"FooterStyle":"footer-module--FooterStyle--2lMN9","TwitterLinkStyle":"footer-module--TwitterLinkStyle--1T2UG"};